export default "__VITE_ASSET__BQ3X89zm__"